import dayjs from 'dayjs'

export type ExportDataHistoryJSON = ExportDataHistory

export type ExportJobType =
  'exportMailMagazineSubscribers'
  | 'exportMembersPaymentHistory'
  | 'exportMembershipHistory'

export type ExportStatus =
  'accepted' |
  'started' |
  'running' |
  'succeeded' |
  'error'

export type ExportConditionIndex =
  'targetMailMagazineIdList' | 'excludeExtensionParamIdList' | 'fromDate' | 'toDate'

export type ExportCondition = {[key in ExportConditionIndex]? : number[] | string}

export type Executor = {
  id: number
  name: string
}

export type ExportRequest = {
  datetime: dayjs.Dayjs
  condition: ExportCondition
  executor: Executor
}

export type ExportResult = {
  fileName: string
  url: string
  total: number
}

export interface ExportDataHistory {
  type: ExportJobType
  id: string
  bucketKey: string
  status: ExportStatus
  request: ExportRequest
  result: ExportResult
}

export class ExportDataHistoryDTO implements ExportDataHistory {
  type: ExportJobType
  id: string
  bucketKey: string
  status: ExportStatus
  request: ExportRequest
  result: ExportResult

  constructor(
    type: ExportJobType,
    id: string,
    bucketKey: string,
    status: ExportStatus,
    request: ExportRequest,
    result: ExportResult,
  ) {
    this.type = type
    this.id = id
    this.bucketKey = bucketKey
    this.status = status
    this.request = request
    this.result = result
  }

  static fromJSON(jsonObject: ExportDataHistoryJSON): ExportDataHistoryDTO {
    const {datetime, ...rest} = jsonObject.request
    return new ExportDataHistoryDTO(
      jsonObject.type,
      jsonObject.id,
      jsonObject.bucketKey,
      jsonObject.status,
      {
        datetime: dayjs(datetime),
        ...rest,
      },
      jsonObject.result,
    )
  }
}
